export default {
  title01: "الطقس الحالي",
  title02: "24 ساعة",
  title03: "عرض توقعات الطقس لمدة 10 أيام",
  title04: "مؤشر جودة الهواء",
  title05: "عرض جميع المعلومات",
  title06: "شروق وغروب الشمس",
  title07: "مراحل القمر",
  title08: "القمر الكامل القادم",
  title09: "القمر الجديد القادم",
  title10: "النهار",
  title11: "الليل",
  title12: "شروق الشمس",
  title13: "غروب الشمس",
  title14: "شروق القمر",
  title15: "غروب القمر",
  title16: "المصدر",
  title17: "البداية",
  title18: "النهاية",
  title19: "استخدام الموقع الحالي",
  title20: "البحث عن المدينة",
  title21: "درجة الحرارة المحسوسة",
  title22: "درجة الحرارة المحسوسة في الظل",
  title23: "الآن",
  title24: "اليوم",
  title25: "الأحد",
  title26: "الاثنين",
  title27: "الثلاثاء",
  title28: "الأربعاء",
  title29: "الخميس",
  title30: "الجمعة",
  title31: "السبت",
  title32: "...جارٍ التحميل",
  title33: "الآن",
  title34: "كل ساعة",
  title35: "يوميًا",
  title36: "الشمس والقمر",
  title37: "جودة الهواء",
  title38: "للتواصل: xlf550402@gmail.com",
  title39: "اتفاقية الخصوصية",
  title40: "حقوق النشر © comfortweather.com 2020 - 2026. جميع الحقوق محفوظة.",
  title41: "البيانات مقدمة من",
  title42: "درجة الحرارة الكبرى",
  title43: "درجة الحرارة الصغرى",
  title44: "قبول",
  title45: "شكرًا لك على استخدام ComfortWeather! لحماية حقوقك ومصالحك القانونية بشكل أفضل، يُرجى قراءة ",
  title46: "سياسة الخصوصية",
  title47: " بعناية قبل الاستخدام.",
  title48: "",
  title49: "للتواصل: xyjph123@gmail.com",
  title50: "حقوق النشر © 24hweather.com 2020 - 2026. جميع الحقوق محفوظة.",
  title51: "شكرًا لك على استخدام 24hweather! لحماية حقوقك ومصالحك القانونية بشكل أفضل، يُرجى قراءة ",
  title52: "لقد تغير موقعك. هل تريد تحديثه؟",
  title53: "تأكيد",
  title54: "الغاء",
  title55: "رجوع",
  title56: "الأخبار",
  title57: "جارٍ تحديث الطقس...",
  title58: "تم تحديث الطقس",
  title59: "عرض الكل ",
  title60: "حقوق النشر © mobi321.com 2020 - 2026. جميع الحقوق محفوظة.",
  title61: "الأمس",
  title62: "غداً",
  title63: "عرض توقعات الطقس لمدة 15 أيام",
  title64: "تفاصيل اليوم ",
  title65: "Rahu Kaal",
  title66: "مؤشرات نمط الحياة",
  title67: "مؤشرات نمط الحياة",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "صعب التجفيف",
  title103: "تجفيف بطيء",
  title104: "يجف جيدًا",
  title105: "تجفيف سريع",
  title106: "تجفيف سريع جدًا",

  title107: "غير مناسب",
  title108: "تجربة متواضعة",
  title109: "جيد للمتعة المائية",
  title110: "مناسب جدًا",
  title111: "ظروف مثالية",

  title112: "مؤيد للصحة",
  title113: "ظروف محايدة",
  title114: "خطر أعلى قليلًا",
  title115: "خطر مرتفع",
  title116: "في خطر شديد",

  title117: "غير مناسب",
  title118: "مناسب إلى حد ما",
  title119: "جيد للأنشطة الخارجية",
  title120: "مناسب جدًا",
  title121: "ظروف ممتازة",

  title122: "حالات جفاف شديدة",
  title123: "مرجح الجفاف",
  title124: "جفاف خفيف",
  title125: "غير محتمل الجفاف",
  title126: "من غير المحتمل جدًا الجفاف",

  title127: "غير موصى به",
  title128: "مقبول",
  title129: "يوم جيد",
  title130: "ظروف ممتازة",
  title131: "ظروف مثالية",
};
